import './index.scss';

export default function StandardPage({
  children,
  center = false,
  className = '',
}) {
  return (
    <div className={ `standard-page-container ${className}` }>
      <div className={ `standard-page-inner ${ center ? 'center' : '' }` }>
        { children }
      </div>
    </div>
  );
};
